import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserSettingsComponent } from './user-settings.component';
import { PlanHistoryComponent } from './plan-history/plan-history.component';
import { PlanHistoryDetailsComponent } from './plan-history-details/plan-history-details.component';

const routes: Routes = [
  { path: 'user-settings/:id', component: UserSettingsComponent},
  { path: 'user-settings/plan-history-details/:id', component: PlanHistoryDetailsComponent},
  { path: 'plan-history', component: PlanHistoryComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserSettingsRoutingModule { }
